<template>
  <pt-live-list class="pt-live-list__page"></pt-live-list>
</template>

<script>
import PtLiveList from 'cps/famous-doctor-hall/pt-live-list/withData'
export default {
  name: 'pt-live-list__view',
  components: {
    'pt-live-list': PtLiveList
  }
}
</script>
